import { scrollTo } from "@/scripts/common/scroll-to";

document.addEventListener("DOMContentLoaded", () => {
  document.documentElement.addEventListener("tab:change", (e) => {
    if (!e.detail.url) {
      return;
    }

    const startTime = performance.now();

    if (window.scrollY > 0) {
      scrollTo(document.body, 150);
    }

    requestAnimationFrame(() => {
      const elapsedTime = performance.now() - startTime;
      const remainingTime = Math.max(0, 200 - elapsedTime);

      setTimeout(() => {
        window.location.href = e.detail.url;
      }, remainingTime);
    });
  });
});
